import type { Distance, Point } from "@pdfking/math"
import { Subtract } from "@pdfking/math"
import { PlotFunction } from "@pdfking/renderer-api"
import type { FolderPath, FolderTemplate } from "@pdfking/templates"

import type { GrowPlotter, PlotContribute } from "#internal"
import { CUT_LAYER_ID, FOLD_LAYER_ID } from "#internal"

/** The die-lines of a folder template drawn at the page — the closed cover
 * — round its depth — the imposition's spine —, of its sheet, turned y up. */
export const PlotFolder =
  (template: FolderTemplate): GrowPlotter =>
  ({ width, height, depth, sheet_depth }) => {
    const die = template.draw(width, height, depth, sheet_depth)
    const up = ({ x, y }: Point<Distance>) => ({ x, y: Subtract(die.height, y) })
    const paths = (drawn: FolderPath[], stroke_color: string) =>
      drawn.map(({ points, closed }) => ({
        enum: PlotFunction.PLOT_PATH,
        stroke_color,
        closed,
        points: points.map(point => ({
          ...up(point),
          before: up(point.before),
          after: up(point.after),
        })),
      }))
    return {
      [CUT_LAYER_ID]: paths(die.cut, "cut"),
      [FOLD_LAYER_ID]: paths(die.fold, "fold"),
    } as PlotContribute
  }
